// Хронология не зависит от порядка прихода WS, REST и старых страниц истории.
export function compareMessages(a, b) {
  const time = value => { const n = Date.parse(value); return Number.isFinite(n) ? n : 0; };
  const dt = time(a?.date_create) - time(b?.date_create);
  if (dt) return dt;
  const ai = Number(a?.id), bi = Number(b?.id);
  if (ai > 0 && bi > 0) return ai - bi;
  if (ai > 0) return -1;
  if (bi > 0) return 1;
  return String(a?.client_uid || a?.id || '').localeCompare(String(b?.client_uid || b?.id || ''));
}
export function orderedMessages(list) {
  const items = [];
  for (const msg of list || []) {
    if (!msg) continue;
    const i = items.findIndex(m => (msg.id != null && String(m.id) === String(msg.id))
      || (msg.client_uid && m.client_uid === msg.client_uid));
    if (i < 0) items.push(msg);
    else {
      const old = items[i];
      // Поздняя временная копия не затирает уже подтверждённое сообщение.
      items[i] = Number(old.id) > 0 && !(Number(msg.id) > 0)
        ? { ...msg, ...old } : { ...old, ...msg };
    }
  }
  return items.sort(compareMessages);
}